module.exports = __webpack_public_path__ + "static/media/cert_67.a5ec1c00.jpg";